import { Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

function FactDropDown(props) {
    const currentQuestions = useSelector((state: any) => state.pickAFile.questions);

    let factList = currentQuestions.map(p => { return ({ "id": "fact", "key": p.dataKey, "text": p.dataKey, "value": p.dataKey }) })

    return (
        <Select
            showSearch
            placeholder='Select Questions'
            options={factList}
            defaultValue={props.defaultValue}
            onChange={props.onChange}
        />
    )
}

export default FactDropDown